var aph_pageLink = window.location + "";
var aph_showHints = false;
var aph_exampleType = "";
var aph_exampleMargin = "10";
var aph_exampleOffset = "42";
var aph_exampleWidth = "70";

if (window.innerWidth > 750) {
    aph_showHints = true;
    if (aph_pageLink.indexOf("colorful-skull-kettlebell-womens-t-shirt") > -1) {
        aph_exampleType = "single";
        aph_exampleMargin = "15";
        aph_exampleOffset = "43";
    } else if (aph_pageLink.indexOf("skull-kettlebell-womens-t-shirt-1") > -1) {
        aph_exampleType = "multi";
        aph_exampleMargin = "12";
        aph_exampleOffset = "46";
    } else if (aph_pageLink.indexOf("womens-short-sleeve-t-shirt-2") > -1) {
        aph_exampleType = "counter";
        aph_exampleMargin = "21";
        aph_exampleOffset = "60";
        aph_exampleWidth = "75";
    } else if (aph_pageLink.indexOf("womens-short-sleeve-t-shirt-1") > -1) {
        aph_exampleType = "shipping";
        aph_exampleMargin = "12";
        aph_exampleOffset = "39";
    } else if (aph_pageLink.indexOf("barbell-womens-t-shirt") > -1) {
        aph_exampleType = "email";
        aph_exampleMargin = "0";
        aph_exampleOffset = "150";
    } else if (aph_pageLink.indexOf("beauty-beast-womens-t-shirt") > -1) {
        aph_exampleType = "ticker";
        aph_exampleMargin = "15";
        aph_exampleOffset = "43";
    } else {
        aph_showHints = false;
    }
}

function createStyles() {
    var styles = "<style>";
    styles += `
        .aphSeeExampleHold {
            float: left;
            width: 450px;
            position: fixed;
            ${aph_exampleType == "email" ? 'bottom: ' + aph_exampleOffset + 'px;' : 'top: ' + aph_exampleOffset + 'px;'}
            left: 300px;
            display: none;
            z-index: 200;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
        }
        .aphSeeExampleHold img {
            float: left;
            width: 100px;
            z-index: 200;
        }
        .aphSeeExampleCont {
            float: left;
            width: 340px;
            margin-top: ${aph_exampleMargin}px;
            margin-left: -2px;
            background-color: #272939;
            padding: 30px 0 15px 0;
            border-radius: 150px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
        .aphSeeExampleContIn {
            float: left;
            width: ${aph_exampleWidth}%;
            color: #cecece;
            position: relative;
            left: 15%;
            font-size: 1.4rem;
        }
        .aphSeeExampleDismiss {
            float: left;
            width: 100%;
            padding: 5px 0;
            text-align: center;
        }
        .aphSeeExampleDismiss span {
            float: left;
        }
        .aphSeeExampleDismiss a {
            color: #e7c656;
        }
        .aphSeeExampleDismiss a:hover {
            text-decoration: underline;
        }
        .aphSeeExampleDismissMiddle {
            padding: 0 15px;
            color: #7a6b43;
            text-align: center;
        }
    `;
    styles += "</style>";
    return styles;
}

function createHtmlContent(ImgSrc, imgStyle) {
    var content = `
        <div class='aphSeeExampleHold'>
            <img src='${ImgSrc}'${imgStyle} />
            <span class='aphSeeExampleCont'>
                <span class='aphSeeExampleContIn'>
                    ${getExampleText()}
                    <span class='aphSeeExampleDismiss'>
                        <span class='aphSeeExampleDismissLeft'>
                            <a href='https://app-hero.myshopify.com/'>More examples</a>
                        </span>
                        <span class='aphSeeExampleDismissMiddle'>|</span>
                        <span class='aphSeeExampleDismissRight'>
                            <a href='javascript:void(0);' onclick='aph_dismissHint(this);'>Dismiss</a>
                        </span>
                    </span>
                </span>
            </span>
        </div>
    `;
    return content;
}

function getExampleText() {
    switch(aph_exampleType) {
        case "single":
            return "Display an announcement bar that you can customize with flexible positioning and styling to match your store design.";
        case "multi":
            return "Display multiple rotating messages in a single banner. Customize the appearance of each message to match your store's design.";
        case "counter":
            return "Display announcements and offers with a countdown timer. Customize the timer settings, position, and style to match your store's design.";
        case "shipping":
            return "Display a free shipping offer that updates automatically based on cart value. To test it, add a product to your cart on this page.";
        case "email":
            return "Display a collapsible email signup form. Customize the style and integrate it with your preferred email marketing apps like Mailchimp and Klaviyo.";
        case "ticker":
            return "Display multiple scrolling announcements in a single bar. Customize the appearance to match your store's design.";
        default:
            return "";
    }
}

function loadAndShowExample(ImgSrc) {
    console.log('Loading example with image:', ImgSrc);
    
    // Check if jQuery is available
    if (typeof jQuery === 'undefined') {
        console.error('jQuery is not loaded!');
        return;
    }

    var newImg = new Image();
    newImg.onload = function() {
        console.log('Image loaded successfully');
        setTimeout(function() {
            var $exampleHold = $(".aphSeeExampleHold");
            if ($exampleHold.length === 0) {
                console.error('Example holder element not found!');
                return;
            }
            
            var tmpOffset = ($(window).width() - $exampleHold.innerWidth()) / 2;
            console.log('Calculated offset:', tmpOffset);
            
            $exampleHold.css({
                display: "block",
                left: tmpOffset + "px",
                opacity: 0
            }).delay(100).animate({ opacity: 1 }, 300);
            
            // Verify the element is visible
            console.log('Element display style:', $exampleHold.css('display'));
        }, 2000); // Changed from 1000 to 2000 for 2 second delay
    };
    
    newImg.onerror = function() {
        console.error('Failed to load image:', ImgSrc);
    };
    
    newImg.src = ImgSrc;
}

function aph_dismissHint() {
    $(".aphSeeExampleHold").css({
        display: "none"
    });
}

// Ensure DOM is ready and jQuery is available
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeExample);
} else {
    initializeExample();
}

function initializeExample() {
    if (typeof jQuery === 'undefined') {
        console.error('jQuery is required but not loaded!');
        return;
    }
    
    if (aph_showHints) {
        console.log('Initializing example with type:', aph_exampleType);
        var ImgSrc = "https://cdn.shopify.com/s/files/1/0437/5419/3050/files/arrow-left-up.png?v=1632225732";
        var htmlString = createStyles();
        
        var imgStyle = "";
        if (aph_exampleType == "email") {
            ImgSrc = "https://cdn.shopify.com/s/files/1/0437/5419/3050/files/arrow-left-down.png?v=1632225732";
            imgStyle = " style='margin-top:113px;'";
        }
        
        htmlString += createHtmlContent(ImgSrc, imgStyle);
        $(htmlString).appendTo("body");
        
        loadAndShowExample(ImgSrc);
    }
}